import { CustomerInterface } from '@app/models/business';
import { CheckboxField } from '../Fields/CheckboxField';
import { useNavigate } from 'react-router-dom';
import { CustomerMenu } from '../CustomerMenu/CustomerMenu';
import UserIcon from '@app/assets/icons/user.svg?react';
import PhoneIcon from '@app/assets/icons/iphone.svg?react';
import MailIcon from '@app/assets/icons/email.svg?react';
import { CustomerTableTruncatedItems } from './CustomerTableTruncatedItems';
import { IntegrationLabels, IntegrationType } from '@app/utils/consts.tsx';

export const CustomerTableRow = ({
  customer,
  addToListAction,
  scheduleCampaignAction,
  deleteCustomerAction,
  handleCheckbox,
  simplified,
  checked,
  disabledActions,
  hideCheckbox = false,
}: {
  customer: CustomerInterface;
  addToListAction?: () => void;
  scheduleCampaignAction?: () => void;
  deleteCustomerAction?: (customer: CustomerInterface) => void;
  handleCheckbox?: (customer?: string) => void;
  simplified?: boolean;
  checked?: boolean;
  disabledActions?: {
    addToList?: boolean;
    deleteCustomer?: boolean;
    scheduleCampaign?: boolean;
  };
  hideCheckbox?: boolean;
}) => {
  const navigate = useNavigate();
  const sourceType = Object.values(IntegrationType).find(
    (type) => type === customer.sourceType
  );

  const goToProfile = () => {
    navigate(`/customers/contacts/${customer.id}`);
  };

  /*
  const status = CustomerStatusMap.get(
    (String(customer.status) ?? 'null') as CustomerStatus
  );
  */

  return (
    <tr
      key={customer.id}
      className={`text-xs cursor-pointer w-full ${
        checked ? 'bg-[#F1F9FF] border-t-2 border-b-2 border-t-[#A8DBFF] border-b-[#A8DBFF]'  : 'border-b border-base-antiFlash hover:bg-brand-lightBlue4'
      } ${!checked ? 'last-of-type:border-b-0' : ''}`}
    >
      {!hideCheckbox && (
          <td className="p-4 min-w-fit w-0 align-middle">
            <CheckboxField
                checked={checked}
                name={`customers.[${customer.id}]`}
                value={customer.id}
                onCheckMark={handleCheckbox}
            />
          </td>
      )}

      <td className="p-4 align-middle" onClick={goToProfile}>
        <div className="flex items-center gap-1 justify-start">
          <div className="flex items-center justify-center w-6 h-6 rounded-sm p-1 bg-base-antiFlash">
            <UserIcon />
          </div>
          <span>
            {customer.firstName} {customer.lastName}
          </span>
        </div>
        <div></div>
        {customer.unsubscribed && (
          <div className="mt-2">
            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800`}>
              Unsubscribed
            </span>
          </div>
        )}
      </td>
      <td className="p-4 align-middle" onClick={goToProfile}>
        <div className="space-y-1">
          {customer.email && (
            <div className="flex gap-1 items-center">
              <div className="flex items-center justify-center w-6 h-6 rounded-sm p-1 bg-base-antiFlash">
                <MailIcon />
              </div>
              <a 
                href={`mailto:${customer.email}`} 
                className="hover:text-brand-baseBlue"
                onClick={(e) => e.stopPropagation()}
              >
                {customer.email}
              </a>
            </div>
          )}
          {customer.phoneNumber && (
            <div className="flex gap-1 items-center">
              <div className="flex items-center justify-center w-6 h-6 rounded-sm p-1 bg-base-antiFlash">
                <PhoneIcon />
              </div>
              <span>{customer.phoneNumber}</span>
            </div>
          )}
        </div>
      </td>
      <td className="p-4 align-middle max-w-[150px]">
        {sourceType ? IntegrationLabels[sourceType] : ''}
      </td>
      <td className="p-4 align-middle max-w-[150px]">
        <CustomerTableTruncatedItems
          items={customer?.lists || []}
          maxVisible={1}
          type="list"
          customerName={`${customer.firstName} ${customer.lastName}`}
        />
      </td>
      <td className="p-4 max-w-[150px]">
        <CustomerTableTruncatedItems 
          items={customer?.tags || []} 
          maxVisible={2} 
          type="tag"
          customerName={`${customer.firstName} ${customer.lastName}`}
        />
      </td>
     {/*
      <td className="p-4 align-middle" onClick={goToProfile}>
        <span
          className={`w-2 h-2 inline-block rounded-full ${status?.color} mr-1`}
        ></span>
        <span>{status?.label}</span>
      </td>
      */}
      <td className="p-4 align-middle">
        <CustomerMenu
          simplified={simplified}
          id={customer.id}
          addToListAction={() => {
            addToListAction && addToListAction();
          }}
          deleteCustomerAction={() => {
            deleteCustomerAction && deleteCustomerAction(customer);
          }}
          scheduleCampaignAction={() => {
            scheduleCampaignAction && scheduleCampaignAction();
          }}
          disabledActions={disabledActions}
        />
      </td>
    </tr>
  );
};
